import { TryOnProvider, TryOnGenericFineTuningSettings, TryOnProduct, TryOnSeller, TryOnFineTuningSettings } from '../../models';
import { MazingPupillaryDistanceStateReceivedMessageType, MazingTryOnReceivedMessageType } from './tryOnProviders/tryOnMazing';

export enum TryOnMode {
	TryOn = 1,
	PDTool = 2
}

export interface TryOnData {
	product?: TryOnProduct;
	customer?: TryOnSeller;
	provider?: TryOnProvider;
	mode?: TryOnMode;
	obj?: Blob | null;
	settings?: TryOnGenericFineTuningSettings;
}

export interface TryOnProviderExchangeData {
	type: TryOnProvidersTypeUnion;
	value: any;
}


export type TryOnProvidersTypeUnion = MazingTryOnReceivedMessageType | MazingPupillaryDistanceStateReceivedMessageType;

export type ValueOf<T> = T[keyof T];

export const TryOnBaseProviderReceivedMessage = {
	Start: '',
	WaitingAuthentication: 'WAITING_AUTH',
	AuthSuccessful: 'AUTH_SUCCESS',
	AuthError: 'AUTH_ERROR',
	WebcamError: 'WEBCAM_ERROR'
} as const;

type TryOnProviderReceivedMessageType = ValueOf<typeof TryOnBaseProviderReceivedMessage>;

export const TryOnBaseProviderResponseMessage = {} as const;

type TryOnBaseProviderResponseMessageType = ValueOf<typeof TryOnBaseProviderResponseMessage>;

export const PupillaryDistanceBaseProviderReceivedMessage = {
	Start: '',
	WaitingAuthentication: 'WAITING_AUTH',
	AuthSuccessful: 'AUTH_SUCCESS',
	AuthError: 'AUTH_ERROR'
} as const;

type PupillaryDistanceProviderReceivedMessageType = ValueOf<typeof PupillaryDistanceBaseProviderReceivedMessage>;

export const PupillaryDistanceBaseProviderResponseMessage = {} as const;

type PupillaryDistanceBaseProviderResponseMessageType = ValueOf<typeof PupillaryDistanceBaseProviderResponseMessage>;

export interface ZakekeTryOnExposedMethods {
	closeFrame?: () => void;
	takeScreenshot?: () => void;
	startPupillaryDistance?: (time: number) => void;
	switchToPDTool?: () => void;
	switchToTryOn?: () => void;
	mode?: TryOnMode;
	changeMode?: (mode: TryOnMode) => void;
	visible?: boolean;
	setVisible?: (visible: boolean) => void;
}

export interface TryOnProviderProps {
	className?: string;
	obj: Blob;
	product: TryOnProduct;
	customer: TryOnSeller;
	fineTuningSettings?: TryOnFineTuningSettings;
	onReady?: () => void;
	onLoaded?: () => void;
	onClose?: () => void;
	onPDUpdated?: (pd: number) => void;
	onWebcamError: () => void;
}

export interface PupillaryDistanceProviderProps {
	className?: string;
	product: TryOnProduct;
	customer: TryOnSeller;
	onReady?: () => void;
	onLoaded?: () => void;
	onPDUpdated?: (pd: number) => void;
	onClose?: () => void;
	onWebcamError: () => void;
}

export function parseJSON(json: string): any {
	try {
		return JSON.parse(json);
	} catch (e) {
		return null;
	}
}
